// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .select-module-button {
    width: 100%;
    min-height: 50px;
    cursor: pointer;
    color: white;
    font-size: larger;
    background: rgba(1, 56, 104, 0.9);
    margin-top: 30px;
  }`, "",{"version":3,"sources":["webpack://./src/web/component/SelectModule/styles.css"],"names":[],"mappings":"CAAC;IACG,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;EAClB","sourcesContent":[" .select-module-button {\r\n    width: 100%;\r\n    min-height: 50px;\r\n    cursor: pointer;\r\n    color: white;\r\n    font-size: larger;\r\n    background: rgba(1, 56, 104, 0.9);\r\n    margin-top: 30px;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
